import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LocationTheftReport } from '../../../../types';

type CellParams = ICellRendererParams<LocationTheftReport>;

@Component({
  selector: 'app-pan-cell-report-portal-type',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-report-portal-type.component.html',
  styleUrl: './cell-report-portal-type.component.scss',
})
export class CellReportPortalTypeComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
